<template>
  <div>
    <!-- <ms-tooltip :tooltip="tooltip"> -->
    <div
      v-if="title"
      class="flex"
    >
      <div class="ms-input-title">
        {{ title }}
      </div>
    </div>
    <!-- </ms-tooltip> -->
    <div :class="['ms-radio-group', `ms-radio-is-vertical-${isVertical}`]">
      <ms-radio
        v-for="(item, index) in radioDatas"
        :key="index"
        v-model="msValueRadio"
        :name="id"
        class="m-r-20 mr-4"
        :key-value="item.value"
        :label="item.label"
        :disabled="disabled || item.disabled"
        :tooltip="item.tooltip"
        @msChange="onChange"
        @beforeChange="onBeforeChange"
      >
        {{ item.title }}
      </ms-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MsRadioGroup',
  emits: ['changeValue'],
  props: {
    radioDatas: {
      type: Array,
      default: null,
    },
    modelValue: {
      type: String || Number || Boolean,
      default: null,
    },
    isVertical: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      id: this.$ms.commonFn.generateUUID(),
    }
  },
  computed: {
    msValueRadio: {
      get () {
        return this.modelValue
      },
      set (newVal) {
        this.$emit('update:modelValue', newVal)
      },
    },
  },
  methods: {
    onChange () {
      this.$emit('changeValue', this.msValueRadio)
    },
    /**
     * TTHuyen 21.09.2020
     * Thêm sự kiện beforeChange trước khi thay đổi
     */
    onBeforeChange (value, eventCustom) {
      this.$emit('beforeChange', value, eventCustom)
    },
  },
}
</script>

<style lang="scss" scoped>
.ms-radio-group {
  display: flex;
}

.ms-radio-is-vertical-true {
  display: grid;
}
.ms-radio-is-vertical-true .ms-radio {
  margin-bottom: 12px;
}

.ms-radio-is-vertical-false .ms-radio {
  margin-right: 20px;
}
.ms-input-title {
  font-size: 12px;
  // font-weight: bold;
  padding-bottom: 6px;
  white-space: nowrap;
  color: #757575;
}
</style>
